import { DEFAULTS } from "./defaults.js";
import { HASHTAG_TYPE } from "./types.js";
import { nodeViewDecorator } from "./viewer/hashtag-decorator.js";
const pluginHashtag = (config) => {
  const pluginConfig = { ...DEFAULTS.config, ...config };
  return {
    config: pluginConfig,
    type: HASHTAG_TYPE,
    nodeViewDecorators: [nodeViewDecorator]
  };
};
export {
  pluginHashtag
};
//# sourceMappingURL=viewer.js.map
